<template>
  <v-container fluid tag="section">
    <v-row v-if="item.patentCode">
      <v-col cols='12' :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
       <span class="font-weight-black"> NO.{{item === undefined  ? '' :  item.patentCode}}</span>
       <span v-if="item.yearCostNumber>0" class="font-weight-black">（第
        <v-chip label x-small color="blue" dark class="pa-2">{{item.yearCostNumber}}</v-chip>
        年年费维护中）</span>
        <v-btn v-has="'patent-cost-edit'" class="px-1 size-13" x-small @click="editModal = { show: true, data : { id: item.id, yearCostNumber: item.yearCostNumber, acceptTime: item.acceptTime, acceptTimeStr: item.acceptTimeStr}}" text color="primary">
          编辑
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        申请人名称：<span class="font-weight-black">{{item === undefined  ? '' :  item.applyUser }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        专利名称：<span class="font-weight-black">{{item === undefined  ? '' :  item.name }}</span>
      </v-col>
     <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        专利类型：<span class="font-weight-black">{{item === undefined  ? '' :  item.patentType | formatPatentType}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        专利状态：<span class="font-weight-black">{{item === undefined  ? '' :  item.statusVal }}</span>
      </v-col>
    </v-row>
     <v-row>
      <v-col cols='12' :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        第一发明人姓名：<span class="font-weight-black">{{item === undefined  ? '' :  item.firstInventorName }}</span>
      </v-col>
     <v-col cols='12' :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        第一发明人身份证：<span class="font-weight-black">{{item === undefined  ? '' :  item.firstInventorCard}}</span>
      </v-col>
      <v-col cols='12' :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        其他发明人：<span class="font-weight-black">{{item === undefined  ? '' :  item.otherInventorName }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        受理费用：<span class="font-weight-black">{{item === undefined || item.acceptFee }}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        受理时间：<span class="font-weight-black">{{item.acceptTime === undefined ? '' : item.acceptTime | formatDay }}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        是否缴纳：<span class="font-weight-black">{{item === undefined || item.acceptFeeStatus === 0 ? '未缴纳' : '已缴纳' }}</span>
        <span v-if="item.acceptEndTime && item.acceptFeeStatus === 0" class="font-weight-black">&nbsp;(截止：{{item.acceptEndTime === undefined ? '' : item.acceptEndTime | formatDay }})</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        授权费用：<span class="font-weight-black">{{item === undefined || item.authFee }}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        授权发文：<span class="font-weight-black">{{item.authTime === undefined ? '' : item.authTime | formatDay }}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        是否缴纳：<span class="font-weight-black">{{item === undefined || item.authFeeStatus === 0 ? '未缴纳' : '已缴纳' }}</span>
        <span v-if="item.authEndTime && item.authFeeStatus === 0" class="font-weight-black">&nbsp;(截止：{{item.authEndTime === undefined ? '' : item.authEndTime | formatDay }})</span>
      </v-col>
    </v-row>
     <v-row>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        授权公告日：<span class="font-weight-black">{{item.certTime === undefined ? '' : item.certTime | formatDay }}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        领证时间：<span class="font-weight-black">{{item.receiveTime === undefined ? '' : item.receiveTime | formatDay }}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        领证人员：
        <span class="font-weight-black">
          {{item.receiveUser === undefined || item.receiveUser === '' || item.receiveUser === null  ? '' :  item.receiveUser.name }}
          <span v-if="item.receiveDesc">
            ({{item.receiveDesc}})
          </span>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        撰写人员：
        <span class="font-weight-black">
          {{item.writeUser === undefined || item.writeUser === '' || item.writeUser === null  ? '' :  item.writeUser.name }}
          <span v-if="item.outWriteTimeStr">
            ({{item.outWriteTimeStr}})
          </span>
        </span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        受理人员：<span class="font-weight-black">{{item.acceptUser === undefined || item.writeUser === '' || item.writeUser === null ? '' :  item.acceptUser.name}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        授权人员：<span class="font-weight-black">{{item.authUser === undefined || item.writeUser === '' || item.writeUser === null ? '' :  item.authUser.name }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        后续跟进人员：<span class="font-weight-black">{{item.operateUser === undefined || item.operateUser === '' || item.operateUser === null ? '' :  item.operateUser.name }}</span>
      </v-col>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <v-row>
      <v-col cols='12' md='6' :class="$isMobile ? 'size-13' : ''">
        受理通知书：
        <span v-if="item.acceptFileName" class="font-weight-black">
          <v-btn class="pl-0" text color="primary" small @click="view(item.acceptFilePath)">{{item.acceptFileName.substring(item.acceptFileName.indexOf("/")+1,item.acceptFileName.length)}}</v-btn>
        </span>
        <span v-else class="font-weight-black">无附件信息</span>
      </v-col>
      <v-col cols='12' md='6' :class="$isMobile ? 'size-13' : ''">
        受理费收据：
        <span v-if="item.acceptCostFilePath !== null && item.acceptCostFilePath.length > 0" class="font-weight-black">
          <v-btn class="pl-0" text color="primary" v-for="(file, index) in item.acceptCostFilePath" :key="index" small @click="view(file)">收据{{index+1}}</v-btn>
        </span>
        <span class="font-weight-black">
          <v-btn class="pl-0" text color="primary" v-has="'patent-cost-edit'" @click="acceptModal = true" small>上传</v-btn>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' md='6' :class="$isMobile ? 'size-13' : ''">
        授权通知书：
        <span v-if="item.authFileName" class="font-weight-black">
          <v-btn class="pl-0" text color="primary" small @click="view(item.authFilePath)">{{item.authFileName.substring(item.authFileName.indexOf("/")+1,item.authFileName.length)}}</v-btn>
        </span>
        <span v-else class="font-weight-black">无附件信息</span>
      </v-col>
      <v-col cols='12' md='6' :class="$isMobile ? 'size-13' : ''">
        授权费收据：
         <span v-if="item.authCostFilePath !== null && item.authCostFilePath.length > 0" class="font-weight-black">
          <v-btn class="pl-0" text color="primary" v-for="(file, index) in item.authCostFilePath" :key="index" small @click="view(file)">收据{{index+1}}</v-btn>
        </span>
        <span class="font-weight-black">
          <v-btn class="pl-0" text color="primary" v-has="'patent-cost-edit'" @click="authModal = true" small>上传</v-btn>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' :class="$isMobile ? 'size-13' : ''">
        电子版证书：
        <span v-if="item.certFileName" class="font-weight-black">
          <v-btn class="pl-0" text color="primary" small @click="view(item.certFilePath)">{{item.certFileName.substring(item.certFileName.indexOf("/")+1,item.certFileName.length)}}</v-btn>
        </span>
        <span v-else class="font-weight-black">无附件信息</span>
      </v-col>
    </v-row>
    <base-material-simple-alert
      :show.sync='acceptModal'
      title='受理费收据补传'
      @on-submit='upoad'
      >
      <template v-slot:content>
        <v-row>
          <v-col>
            <file-upload
              label="收据上传(命名：专利号_受理费收据.pdf)"
              outlined
              small-chips
              multiple
              prepend-icon=''
              accept=".pdf"
              :bucket='bucket'
              @on-files='onAcceptFileName'
            />
          </v-col>
        </v-row>
        可多选，本次上传将覆盖上次上传信息，请谨慎操作！
      </template>
    </base-material-simple-alert>
    <base-material-simple-alert
      :show.sync='authModal'
      title='授权费收据补传'
      @on-submit='upoad'
    >
    <template v-slot:content>
        <v-row>
          <v-col>
            <file-upload
              label="收据上传(命名：专利号_授权费收据.pdf)"
              outlined
              small-chips
              multiple
              prepend-icon=''
              accept=".pdf"
              :bucket='bucket'
              @on-files='onAuthFileName'
            />
          </v-col>
        </v-row>
        可多选，本次上传将覆盖上次上传信息，请谨慎操作！
      </template>
    </base-material-simple-alert>
    <edit-year :item="editModal" @on-load-data="onLoadData"></edit-year>
  </v-container>
</template>

<script>
  import { edit } from '@/api/patent/index.js'
  import FileUpload from '@/components/oss/Index.vue'
  import EditYear from './EditYear.vue'

  export default {
    name: 'PatentDetail',
    components: {
      EditYear,
      FileUpload
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      lazy: {
        type: Boolean,
        default: false
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        editModal: { show: false, data: {} },
        bucket: 'yd-patent',
        acceptModal: false,
        authModal: false,
        form: {
          id: ''
        }
      }
    },
    methods: {
      view (path) {
        if (path) {
          window.open(
            path,
            "_blank"
          );
        }
      },
      onAcceptFileName (fileNames) {
        let acceptCostFileName = ''
        fileNames.forEach(name => {
          acceptCostFileName += `${this.bucket}/${name},`
        })
        this.form.acceptCostFileName = acceptCostFileName.substring(0, acceptCostFileName.lastIndexOf(','))
      },
      onAuthFileName (fileNames) {
        let authCostFileName = ''
        fileNames.forEach(name => {
          authCostFileName += `${this.bucket}/${name},`
        })
        this.form.authCostFileName = authCostFileName.substring(0, authCostFileName.lastIndexOf(','))
      },
      onLoadData () {
        this.$emit('on-load-data')
      },
      upoad () {
        this.form.id = this.item.id
        edit(this.form).then(res => {
          if (res.status === 200) {
            this.acceptModal = false
            this.authModal = false
            this.$emit('on-load-data')
            this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
          }
        })
      }
    }
  }
</script>

<style lang="sass">
  #system-user-detail-page
    .custom-font
      color: white !important
</style>
